/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
export enum InsuranceControlItemIdEnum {
    MoveHouse,
    ChangePersonalData,
    CoInsureChildren,
    LivingTogether,
    Marrage,
    BreakUp,
    Death,
    ChangeCredentials,
    DamageReport,
    DamageFreeYears,
    InsuranceAdd,
    InsuranceEdit,
    InsuranceCancel,
    CarRegistrationReplace,
    MotorcycleRegistrationReplace,
    SwitchToInShared,
    Invoices,
    DamageStatus,
    InsuranceOverview,
    TermsOverview,
    DownloadInsuranceCertificate,
}
